/* dcnt. collection: client-side filter + sort with bottom sheets */
(function () {
  function init() {
    var root = document.querySelector('[data-coll]');
    if (!root) return;
    var grid = root.querySelector('[data-grid]');
    if (!grid) return;
    var items = [].slice.call(grid.querySelectorAll('.d-ci'));
    var chips = [].slice.call(root.querySelectorAll('.d-chip'));
    var sortBtns = [].slice.call(root.querySelectorAll('[data-sort]'));
    var empty = root.querySelector('[data-empty]');
    var tool = root.querySelector('[data-ctool]');
    var GROUPS = ['g', 'fam', 'style', 'perf', 'brand'];
    var SORT_LABEL = { featured: '', 'price-asc': 'Price ↑', 'price-desc': 'Price ↓', longevity: 'Longevity', name: 'A–Z' };

    // parse item data once
    items.forEach(function (el) {
      var d = el.dataset;
      el._d = {
        i: +d.i, price: +d.price, title: (d.title || '').toLowerCase(),
        g: [d.g], fam: (d.fam || '').split(/\s+/), style: (d.style || '').split(/\s+/), brand: [d.brand],
        perf: [(+d.lon >= 4) ? 'long' : '', (+d.sil >= 3) ? 'loud' : ''], lon: +d.lon
      };
    });

    var state = { f: {}, sort: 'featured' };
    GROUPS.forEach(function (g) { state.f[g] = []; });

    // restore from URL
    try {
      var q = new URLSearchParams(location.search);
      GROUPS.forEach(function (g) { var v = q.get('f_' + g); if (v) state.f[g] = v.split(',').filter(Boolean); });
      if (q.get('sort') && SORT_LABEL.hasOwnProperty(q.get('sort'))) state.sort = q.get('sort');
    } catch (e) {}

    function matches(d, skip) {
      for (var k = 0; k < GROUPS.length; k++) {
        var g = GROUPS[k];
        if (g === skip) continue;
        var want = state.f[g];
        if (!want.length) continue;
        var ok = false;
        for (var j = 0; j < want.length; j++) if (d[g].indexOf(want[j]) > -1) { ok = true; break; }
        if (!ok) return false;
      }
      return true;
    }

    function sorter(a, b) {
      var A = a._d, B = b._d;
      switch (state.sort) {
        case 'price-asc': return A.price - B.price || A.i - B.i;
        case 'price-desc': return B.price - A.price || A.i - B.i;
        case 'longevity': return B.lon - A.lon || A.i - B.i;
        case 'name': return A.title < B.title ? -1 : A.title > B.title ? 1 : 0;
        default: return A.i - B.i;
      }
    }

    function syncURL() {
      try {
        var q = new URLSearchParams(location.search);
        GROUPS.forEach(function (g) { state.f[g].length ? q.set('f_' + g, state.f[g].join(',')) : q.delete('f_' + g); });
        state.sort !== 'featured' ? q.set('sort', state.sort) : q.delete('sort');
        var s = q.toString();
        history.replaceState(null, '', location.pathname + (s ? '?' + s : '') + location.hash);
      } catch (e) {}
    }

    function render(reorder) {
      var shown = 0;
      items.forEach(function (el) {
        var ok = matches(el._d);
        if (ok) shown++;
        if (el.hidden === ok) el.hidden = !ok;
      });
      if (reorder) items.slice().sort(sorter).forEach(function (el) { grid.appendChild(el); });

      // chip states + facet counts
      chips.forEach(function (c) {
        var g = c.dataset.f, v = c.dataset.v;
        var on = state.f[g].indexOf(v) > -1;
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
        var n = 0;
        items.forEach(function (el) { if (el._d[g].indexOf(v) > -1 && matches(el._d, g)) n++; });
        var nEl = c.querySelector('.d-chip__n');
        if (nEl) nEl.textContent = n;
        c.disabled = !on && n === 0;
      });

      var active = GROUPS.reduce(function (s, g) { return s + state.f[g].length; }, 0);
      var word = shown === 1 ? 'perfume' : 'perfumes';
      root.querySelectorAll('[data-count]').forEach(function (e) { e.textContent = shown + ' ' + word; });
      root.querySelectorAll('[data-count-n]').forEach(function (e) { e.textContent = shown; });
      root.querySelectorAll('[data-count-w]').forEach(function (e) { e.textContent = word; });
      root.querySelectorAll('[data-fcount]').forEach(function (e) { e.textContent = active; e.hidden = !active; });
      root.querySelectorAll('.d-sheet__clear').forEach(function (e) { e.disabled = !active; });
      root.querySelectorAll('[data-sort-label]').forEach(function (e) { e.textContent = SORT_LABEL[state.sort]; });
      root.querySelectorAll('[data-sheet-open]').forEach(function (b) { b.classList.toggle('is-on', b.dataset.sheetOpen === 'filter' ? active > 0 : state.sort !== 'featured'); });
      sortBtns.forEach(function (b) { b.setAttribute('aria-checked', b.dataset.sort === state.sort ? 'true' : 'false'); });
      if (empty) empty.hidden = shown > 0;
      syncURL();
    }

    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var arr = state.f[c.dataset.f], v = c.dataset.v, i = arr.indexOf(v);
        i > -1 ? arr.splice(i, 1) : arr.push(v);
        render(false);
      });
    });
    root.querySelectorAll('[data-clear]').forEach(function (b) {
      b.addEventListener('click', function () { GROUPS.forEach(function (g) { state.f[g] = []; }); render(false); });
    });
    sortBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        state.sort = b.dataset.sort;
        render(true);
        setTimeout(function () { closeSheet(); }, 220);
        var top = tool ? tool.getBoundingClientRect().top + window.pageYOffset - (parseFloat(getComputedStyle(tool).top) || 0) : 0;
        if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });

    // ---------- bottom sheets ----------
    var openSheetEl = null, lastTrigger = null;
    function openSheet(name, trigger) {
      var s = root.querySelector('[data-sheet="' + name + '"]');
      if (!s) return;
      if (openSheetEl) closeSheet(true);
      lastTrigger = trigger || null;
      openSheetEl = s;
      s.removeAttribute('inert');
      s.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('d-lock-sheet');
      requestAnimationFrame(function () {
        s.classList.add('is-open');
        var p = s.querySelector('[data-sheet-panel]');
        if (p) p.focus({ preventScroll: true });
      });
    }
    function closeSheet(instant) {
      var s = openSheetEl;
      if (!s) return;
      openSheetEl = null;
      s.classList.remove('is-open');
      var p = s.querySelector('[data-sheet-panel]');
      if (p) p.style.removeProperty('--drag');
      s.setAttribute('aria-hidden', 'true');
      s.setAttribute('inert', '');
      document.documentElement.classList.remove('d-lock-sheet');
      if (lastTrigger && !instant) lastTrigger.focus({ preventScroll: true });
    }
    root.querySelectorAll('[data-sheet-open]').forEach(function (b) {
      b.addEventListener('click', function () { openSheet(b.dataset.sheetOpen, b); });
    });
    root.querySelectorAll('[data-sheet-close]').forEach(function (b) {
      b.addEventListener('click', function () { closeSheet(); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openSheetEl) closeSheet(); });

    // drag down to dismiss
    root.querySelectorAll('[data-sheet-panel]').forEach(function (p) {
      var y0 = null, dy = 0, t0 = 0;
      p.querySelectorAll('[data-sheet-grab]').forEach(function (h) {
        h.addEventListener('pointerdown', function (e) {
          if (e.target.closest('button')) return;
          y0 = e.clientY; dy = 0; t0 = Date.now();
          p.classList.add('is-dragging');
          try { h.setPointerCapture(e.pointerId); } catch (_) {}
        });
        h.addEventListener('pointermove', function (e) {
          if (y0 === null) return;
          dy = Math.max(0, e.clientY - y0);
          p.style.setProperty('--drag', dy + 'px');
        });
        function end() {
          if (y0 === null) return;
          y0 = null;
          p.classList.remove('is-dragging');
          var v = dy / Math.max(1, Date.now() - t0);
          if (dy > 110 || v > 0.6) closeSheet(); else p.style.removeProperty('--drag');
        }
        h.addEventListener('pointerup', end);
        h.addEventListener('pointercancel', end);
      });
    });

    // toolbar: sit under the sticky header, show hairline once stuck
    function headerH() {
      var h = document.querySelector('.d-head');
      var v = h ? Math.round(h.getBoundingClientRect().height) : 57;
      document.documentElement.style.setProperty('--d-hh', v + 'px');
    }
    headerH();
    window.addEventListener('resize', headerH);
    if (tool && 'IntersectionObserver' in window) {
      var sentinel = document.createElement('div');
      sentinel.style.cssText = 'height:1px;margin-bottom:-1px';
      tool.parentNode.insertBefore(sentinel, tool);
      new IntersectionObserver(function (en) {
        tool.classList.toggle('is-stuck', !en[0].isIntersecting);
      }, { rootMargin: '-' + (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--d-hh')) || 57) + 'px 0px 0px 0px' }).observe(sentinel);
    }

    render(state.sort !== 'featured');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
